<div class="kDashboard">
  <div id="appMenu" #appMenu>
    <kKMCAppMenu></kKMCAppMenu>
    <div class="kPopupWidgetModalOverlay kMenuCover"></div>
  </div>
  <router-outlet></router-outlet>
  <kScrollToTop [scrollOffset]="50"></kScrollToTop>
</div>

<kPopupWidget #whatsNew data-aid="whatsNew" [popupWidth]="644" [popupHeight]="617" [modal]="true" [closeBtn]="true">
  <div class="whatsNew">
    <img width="644" height="284" [src]="_bannerUri" />
    <div class="kHeader">
      <span class="kTitle">Welcome to Connect</span>
    </div>
    <div class="kWelcomeContent">
      <span
        >Join us for our user conference, for speakers from across the video ecosystem, roadmap sessions for Kaltura
        products, exhibitors, opportunities to speak to the Kaltura product team, and an optional training day.</span
      >
    </div>

    <div class="kFooter">
      <button class="kButtonBranded" type="button" pButton label="Register Now" (click)="register()"></button>
    </div>
  </div>
</kPopupWidget>
